module.exports = __webpack_public_path__ + "img/index_first_screen_banner.dc1ce9fa.png";